import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getShiftList = (page, pagesize) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/shift-master/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
    },
  });
};

const addShift = payload => {
  console.log(payload)
  return axios.post(
    `${API_URL}/api/${API_VERSION}/shift-master/`,
    payload,
    { headers: authHeader() }
  );
};

const editShift = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/shift-master/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const deleteShift = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/shift-master/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};


const shiftService = {
  getShiftList,
  addShift,
  editShift,
  deleteShift
};
export default shiftService;


